
import { useTranslation } from "react-i18next";
import Hero from "../../components/root/Hero";
import person1 from "../../assets/new images/person1.png";
import person2 from "../../assets/new images/person2.png";
import person3 from "../../assets/new images/person3.png";
import backgroundImage from "../../assets/new images/Aboutus.png";
import TeamBioSection from "../../components/root/TeamBioSection";
import AboutCabil from "../../components/root/AboutCabil";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";
const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <div className="font-sans overflow-x-hidden">
      <Seo
        {...SEO["/about-us"]}
        path="/about-us"
      />

      <Hero bgImage={backgroundImage}
        badgeText={`✨ ${t("hero.badge")}`}
        titleLines={[t("aboutUs.heroTitle")]}
        subtitle=""
        primary={{ label: t("hero.findMentor"), href: "/find-mentor" }}
        secondary={{ label: t("hero.tryAi"), href: "/ai-career" }}
        curveColor="#F9FAFB"     // match the next section's background (e.g., Tailwind bg-gray-50)
        heightClass="h-[100vh] min-h-[560px]"
        overlayClass="bg-gradient-to-b from-black/55 via-black/35 to-black/25"
        roundedButtons={true} />

      <AboutCabil />
      <>
        <TeamBioSection
          heading={t("aboutUs.team.azka.heading")}
          subheading={t("aboutUs.team.azka.subheading")}
          img={person1}
          body={t("aboutUs.team.azka.body")}
        />

        <TeamBioSection
          heading={t("aboutUs.team.amara.heading")}
          subheading={t("aboutUs.team.amara.subheading")}
          img={person2}
          body={t("aboutUs.team.amara.body")}
          reverse
          // you can tweak accent colors per section if needed:
          accentLeft="#3141B3"
          accentRight="#FF6A33"
        />

        {/* NOTE: pre-existing typo in original heading "Syed Saad Imamn" -> should be "Imam"; preserved verbatim in aboutUs.team.saad.heading */}
        <TeamBioSection
          heading={t("aboutUs.team.saad.heading")}
          subheading={t("aboutUs.team.saad.subheading")}
          body={t("aboutUs.team.saad.body")}
          img={person3}
        />
      </>


    </div>
  );
};

export default AboutUs;
